// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  RejectedMint,
  MintRequest,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { RequestState, RequestType, RowNew } from '../components/Table/types';
import TemplateContract from './TemplateContract';

export type MintTemplateUnion = TemplateContract<MintRequest> | TemplateContract<RejectedMint>;

const genericMintMapper = (
  contract: MintTemplateUnion,
  requestType: RequestType,
  requestState: RequestState,
) => {
  const commonFields = {
    contractId: contract.contractId,
    createdAt: contract.createdAt,
    amount: contract.payload.mint.amount,
    reference: contract.payload.mint.reference,
    holder: contract.payload.mint.holder,
    sender: contract.payload.mint.holder,
    requestType,
    requestState,
    templateId: contract.templateId,
  };

  const flattened: RowNew = {
    ...commonFields,
    receiver: '',
    reason: '',
    operator: '',
    provider: '',
    instrumentId: '',
    registrar: '',
    holdingLabel: '',
  };

  flattened.operator = contract.payload.operator;
  flattened.provider = contract.payload.provider;

  if ('reason' in contract.payload) {
    flattened.reason = contract.payload.reason;
  }

  flattened.instrumentId = contract.payload.mint.instrumentId.id;
  flattened.registrar = contract.payload.mint.instrumentId.admin;
  flattened.receiver = contract.payload.mint.instrumentId.admin;

  return flattened;
};

export const flattenMints = (contracts: MintTemplateUnion[], requestState: RequestState) => {
  return contracts.map((c) => genericMintMapper(c, RequestType.Mint, requestState));
};
